import createReactComponent from '../createReactComponent';
var Dice6 = createReactComponent('Dice6', [['rect', {
  x: '3',
  y: '3',
  width: '18',
  height: '18',
  rx: '2',
  ry: '2',
  key: 'maln0c'
}], ['path', {
  d: 'M16 8h.01',
  key: 'cr5u4v'
}], ['path', {
  d: 'M16 12h.01',
  key: '1l6xoz'
}], ['path', {
  d: 'M16 16h.01',
  key: '1f9h7w'
}], ['path', {
  d: 'M8 8h.01',
  key: '1e4136'
}], ['path', {
  d: 'M8 12h.01',
  key: 'czm47f'
}], ['path', {
  d: 'M8 16h.01',
  key: '18s6g9'
}]]);
export default Dice6;